import Image from "next/legacy/image";
import Link from "@/utils/link";

import HomeHeader from "@/components/home/HomeHeader";
import SeoLinks from "@/components/home/SeoLinks";
import HomeFooter from "@/components/home/HomeFooter";

import GetStartedCreate from "@/components/Logo/GetStartedCreate";
import GetStartedUpdate from "@/components/Logo/GetStartedUpdate";
import GetStartedUpgrade from "@/components/Logo/GetStartedUpgrade";

import { imageLoader } from "@/utils/image";
import Button from "@/ui/Button";

const CpGetStarted = () => {
    return (
        <div className="relative h-screen">
            <HomeHeader fixed />

            <div className="relative">
                <div className="sm:hidden relative w-full h-72">
                    <Image
                        loader={imageLoader}
                        src="https://cdn.purpledoorfinders.com/purpledoorfinders/purpledoorfinders-about-us"
                        alt="about us"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="left top"
                        priority
                        unoptimized={false}
                        className=""
                    />
                </div>

                <div className="container mx-auto px-8 sm:px-16">
                    <div className="w-full sm:w-1/2 pt-8 sm:pt-32 pr-8 min-h-[600px]">
                        <h2 className="text-gray-sec text-2xl font-bold tracking-normal font-headline uppercase">
                            For Communities
                        </h2>
                        <h1 className="mt-2 text-primary-500 text-4xl font-bold tracking-normal font-headline">
                            Get Started
                        </h1>

                        <p className="mt-12 pb-8 text-lg">
                            Finding and connecting with prospective residents has never been
                            easier. Purple Door Finders is the first site dedicated to
                            providing communities with ability to share the valuable
                            information about their communities with well informed
                            prospective residents.
                        </p>

                        <div className="mt-8">
                            <Button
                                className="w-64"
                                size="xl"
                                href="/community-portal/my-communities"
                            >
                                Manage Communities
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="hidden sm:block absolute top-0 left-1/2 right-0 bottom-0">
                    <Image
                        loader={imageLoader}
                        src="https://cdn.purpledoorfinders.com/purpledoorfinders/purpledoorfinders-about-us"
                        alt="about us"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="left top"
                        priority
                        unoptimized={false}
                        className=""
                    />
                </div>
            </div>

            <div className="bg-gray-light">
                <div className="container mx-auto px-8 sm:px-16">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-x-16 py-16">
                        <Card
                            index="1"
                            title="Create or Claim Community"
                            Logo={GetStartedCreate}
                            href="/community-portal/my-communities"
                        ></Card>

                        <Card
                            index="2"
                            title="Update Community"
                            Logo={GetStartedUpdate}
                            href="/community-portal/my-communities"
                        ></Card>

                        <Card
                            index="3"
                            title="Upgrade Community"
                            Logo={GetStartedUpgrade}
                            href="/community-portal/my-communities"
                        ></Card>
                    </div>
                </div>
            </div>

            <div className="container mx-auto px-8 sm:px-16">
                <div className="py-16 text-center">
                    <h3 className="text-primary-500 text-4xl font-headline font-bold">
                        Have More Questions?
                    </h3>

                    <div className="mt-8 flex justify-center space-x-16">
                        <Button size="lg" href="/community-portal/support">
                            Support
                        </Button>
                    </div>
                </div>
            </div>

            <SeoLinks />
            <HomeFooter />
        </div>
    );
};

const Card = ({ index, title, children, Logo, href = "/" }) => {
    return (
        <Link href={href}>
            <a className="flex flex-col items-center text-center">
                <div className="relative">
                    <div className="absolute top-4 -left-16 text-6xl text-gray-500">
                        {index}
                    </div>
                    <Logo />
                </div>
                <h3 className="mt-8 h-24 text-primary-500 text-3xl font-headline font-bold uppercase">
                    {title}
                </h3>
                <p className="text-lg">{children}</p>
                sdfsdfsdf
            </a>
        </Link>
    );
};

export default CpGetStarted;
